import { Grid } from '@material-ui/core';

interface IProps {
    children: React.ReactNode
    onSubmit?: () => void
}

let FilterContainer = ({ children, onSubmit }: IProps) => {
    return (
        <form onSubmit={(e) => {
            if (onSubmit) {
                e.preventDefault();
                onSubmit()
            }
        }}>
            <Grid container alignItems="center">
                {children}
            </Grid>
        </form>
    )
}


export default FilterContainer;